import { render } from "./app-dialog2.vue?vue&type=template&id=25e56520&scoped=true"
import script from "./app-dialog2.vue?vue&type=script&lang=js"
export * from "./app-dialog2.vue?vue&type=script&lang=js"

import "./app-dialog2.vue?vue&type=style&index=0&id=25e56520&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25e56520"]])

export default __exports__